package org.ksdfv.thelema.g3d.cam

import org.ksdfv.thelema.app.APP
import org.ksdfv.thelema.math.IMat4
import org.ksdfv.thelema.math.IVec3
import org.ksdfv.thelema.math.Mat4
import org.ksdfv.thelema.math.Vec3

/** @author zeganstyl */
class Camera(
    override val position: IVec3 = Vec3(),
    override val direction: IVec3 = Vec3(1f, 0f, 0f),
    override val up: IVec3 = Vec3(0f, 1f, 0f),
    override var near: Float = 0.1f,
    override var far: Float = 100f,
    override var fov: Float = 60f,
    override var viewportWidth: Float = APP.width.toFloat(),
    override var viewportHeight: Float = APP.height.toFloat(),
    override var isOrthographic: Boolean = false,
    override var zoom: Float = 1f,
    override var name: String = "",
    override var isCentered: Boolean = true
): CameraAdapter() {
    constructor(position: IVec3, target: IVec3, near: Float = 0.1f, far: Float = 100f): this(near = near, far = far) {
        lookAt(position, target)
        update()
    }

    override val viewMatrix: IMat4 = Mat4().setToLook(position, direction, up)
    override val projectionMatrix: IMat4 = Mat4().setToProjection(near, far, fov, aspectRatio)
    override val viewProjectionMatrix: IMat4 = Mat4().set(projectionMatrix).mul(projectionMatrix)

    override fun copy(): ICamera = Camera().set(this)
}